import { render, staticRenderFns } from "./TrademarkInfo.vue?vue&type=template&id=e15a9e5c&"
import script from "./TrademarkInfo.vue?vue&type=script&lang=js&"
export * from "./TrademarkInfo.vue?vue&type=script&lang=js&"
import style0 from "./TrademarkInfo.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports